import { createSelector } from '@reduxjs/toolkit';

import { GlobalState } from '@/redux/store';

const stateSelector = (state: GlobalState) => state;
const bidderExistsSlice = createSelector(stateSelector, (state) => state.bidderExists);

export const getBidderExists = createSelector(bidderExistsSlice, (state) => Boolean(state.email));

export const getBidderExistsEmail = createSelector(bidderExistsSlice, (state) => state.email);
